export default {
   'features': 'Funktionen',
   'downloads': 'Downloads',
   'roadmap': 'Roadmap',
   'price': 'Preis',
   'donate': 'Spenden',
   'feedback': 'Feedback',
   'panel': 'Steuerungspanel',
};
